import React from 'react';
import { DocumentPreviewRenderer, useDocumentBlob } from 'domain/shared/documentStorage';
import { EnumField } from 'framework/ui/field';
import { Box, Typography } from '@mui/material';
import { EmployeeOfficeField, EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import { MESSAGE_MODAL_FORM_CONTEXT } from 'framework/form';
import { ProcessAssetsFormType } from '../types';
import { OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES, OPERATIONAL_ASSETS_DOCUMENT_SECTIONS_VALUES } from '../constants';

const ProcessAssetFormPreview = ({
  formData,
  documentPath,
}: {
  formData: ProcessAssetsFormType;
  documentPath: string;
}) => {
  const { templateName, owner, section, fileType, office, internalId, templateId } = formData || {};
  const { blobUrl, loading, hasError } = useDocumentBlob(documentPath);

  return (
    <Box display="flex" justifyContent="space-between">
      <Box width="45%">
        <Typography variant="h4" mb={2}>
          {templateName}
        </Typography>

        <Box display="flex" mb={1}>
          <Typography flexBasis="25%">Owner:</Typography>
          <EmployeeLinkFieldWithNameLoading value={owner} />
        </Box>

        <Box display="flex" mb={1}>
          <Typography flexBasis="25%">Office:</Typography>
          <EmployeeOfficeField value={Number(office)} />
        </Box>

        <Box display="flex" mb={1}>
          <Typography flexBasis="25%">Section:</Typography>
          <EnumField value={section} options={OPERATIONAL_ASSETS_DOCUMENT_SECTIONS_VALUES} />
        </Box>

        <Box display="flex" mb={1}>
          <Typography flexBasis="25%">File type:</Typography>
          <EnumField
            value={fileType}
            options={{
              ...OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES,
            }}
          />
        </Box>

        {internalId && (
          <Box display="flex" mb={1}>
            <Typography flexBasis="25%">Internal ID:</Typography>
            <Typography>{internalId}</Typography>
          </Box>
        )}

        {templateId && (
          <Box display="flex" mb={1}>
            <Typography flexBasis="25%">Template ID:</Typography>
            <Typography>{templateId}</Typography>
          </Box>
        )}
      </Box>

      <Box width="55%">
        <DocumentPreviewRenderer
          documentPath={documentPath}
          blobUrl={blobUrl}
          loading={loading}
          hasError={hasError}
          defaultScale={0.5}
          messageContext={MESSAGE_MODAL_FORM_CONTEXT}
        />
      </Box>
    </Box>
  );
};

export default ProcessAssetFormPreview;
